import * as services from '../services';

export default {
  namespace: 'der',

  state: {
    executionRecordList: {},
  },

  effects: {
    *getExecutionRecord({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        services.getExecutionRecord,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          executionRecordList: response || {},
        },
      });
    },
  },
  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
